import BannerSlider from "components/banner-slider";
import TheBanner from "layout/TheBanner/TheBanner";
import TheFooter from "layout/TheFooter";
import TheHeader from "layout/TheHeader";
import React, { useEffect, useRef, useState } from "react";
import { calcDayInWeek, urlAssetsCustom } from "utils/common";
import "react-date-picker/dist/DatePicker.css";
import "react-calendar/dist/Calendar.css";
import { useDispatch, useSelector } from "react-redux";
import actions from "redux/home/actions";
import { LINK_VIDEO } from "constants/common";
import { UploadFile } from "utils/uploadBlob";
const HomeView = (props) => {
  const {
    handleContinue,
    handleOpenModalImage,
    handleOpenModalCard,
    contentCard,
    setContentCard,
  } = props;
  const dispatch = useDispatch();
  const isEnableButtonRegister = useRef(false);
  const [cardPhotographer, setCardPhotoGrapher] = useState([]);
  const [cardPhotoUser, setCardPhotoUser] = useState([]);
  const [showForm, setShowForm] = useState(false);
  const [page, setPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [totalCard, setTotalCard] = useState(0);
  const [loadingCardUser, setLoadingCardUser] = useState(false);
  const convertArrPhotoUser = (item) => {
    let finalCard = [];
    for (let i = 0; i <= item.length - 1; i += 3) {
      if (i <= item.length - 3) {
        finalCard.push(
          {
            slider: [{ card: item[i] }],
          },
          {
            slider: [{ card: item[i + 1] }, { card: item[i + 2] }],
          }
        );
      } else if (i <= item.length - 2) {
        finalCard.push(
          {
            slider: [{ card: item[i] }],
          },
          {
            slider: [{ card: item[i + 1] }],
          }
        );
      } else {
        finalCard.push({
          slider: [{ card: item[i] }],
        });
      }
    }
    return finalCard;
  };
  useEffect(() => {
    dispatch(
      actions.COUNT_CARDS.request({}, (res) => {
        setTotalCard(res?.data);
        dispatch(
          actions.GET_CARDS.request(
            {
              isFromUser: false,
              pageSize: res.data,
              page: 1,
            },
            (res) => {
              setCardPhotoGrapher(res?.data?.data);
              console.log("setCardPhotoGrapher", res?.data?.data);
            }
          )
        );
      })
    );
  }, []);

  const fetchGetCardUser = (page) => {
    setLoadingCardUser(true);
    dispatch(
      actions.GET_CARDS.request(
        {
          isFromUser: true,
          pageSize: 100,
          page: page,
        },
        (res) => {
          setLoadingCardUser(false);
          setTotalPages(Math.ceil(res?.data?.total / 100));
          if (window.screen.width > 992) {
            setCardPhotoUser((prev) => [
              ...prev,
              ...convertArrPhotoUser(res?.data?.data),
            ]);
          } else {
            setCardPhotoUser((prev) => [...prev, ...res?.data?.data]);
          }
        },
        (err) => {
          setLoadingCardUser(false);
        }
      )
    );
  };
  console.log("cardPhotoUser", cardPhotoUser);
  const handleSlideChange = (index) => {
    if (loadingCardUser) return;
    if (index >= cardPhotoUser.length - 2 && page < totalPages) {
      setPage((prev) => prev + 1); // Fetch next page when near end
    }
  };
  useEffect(() => {
    fetchGetCardUser(page);
  }, [page]);

  const removeDisableBtn = (id) => {
    const el = document.querySelector(id);
    el.classList.remove("disabled");
    isEnableButtonRegister.current = true;
  };
  let listSliderSetting = {};
  let listSliderSetting1 = {};
  if (window.screen.width > 992) {
    const t = {
      slidesToShow: 5,
      slidesToScroll: 1,
      centerMode: true,
      arrows: true,
      dots: false,
      speed: 300,
      centerPadding: "20px",
      infinite: true,
      autoplaySpeed: 5000,
      autoplay: true,
      lazyLoad: false,
      responsive: [
        {
          breakpoint: 1024,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
            infinite: true,
            dots: true,
          },
        },
        {
          breakpoint: 600,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
          },
        },
        {
          breakpoint: 480,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
          },
        },
      ],
    };
    const t1 = {
      slidesToShow: 3,
      slidesToScroll: 1,
      dots: false,
      centerPadding: "20px",
      centerMode: true,
      focusOnSelect: true,
      variableWidth: true,
      autoplaySpeed: 5000,
      autoplay: true,
      lazyLoad: false,
      afterChange: handleSlideChange,
      responsive: [
        {
          breakpoint: 1024,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
          },
        },
        {
          breakpoint: 600,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
          },
        },
        {
          breakpoint: 480,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
          },
        },
      ],
    };
    listSliderSetting = t;
    listSliderSetting1 = t1;
  } else {
    const t = {
      slidesToShow: 1,
      slidesToScroll: 1,
      centerMode: true,
      arrows: true,
      dots: false,
      speed: 300,
      centerPadding: "20px",
      infinite: true,
      autoplaySpeed: 5000,
      autoplay: true,
      lazyLoad: false,
      responsive: [
        {
          breakpoint: 1024,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
            infinite: true,
            dots: true,
          },
        },
        {
          breakpoint: 600,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
          },
        },
        {
          breakpoint: 480,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
          },
        },
      ],
    };
    const t1 = {
      slidesToShow: 1,
      slidesToScroll: 1,
      dots: false,
      centerPadding: "20px",
      centerMode: true,
      focusOnSelect: true,
      variableWidth: true,
      autoplaySpeed: 5000,
      autoplay: true,
      lazyLoad: false,
      afterChange: handleSlideChange,
      responsive: [
        {
          breakpoint: 1024,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
          },
        },
        {
          breakpoint: 600,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
          },
        },
        {
          breakpoint: 480,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
          },
        },
      ],
    };
    listSliderSetting = t;
    listSliderSetting1 = t1;
  }
  const listSlider1 = [
    {
      slider: [
        { image: "assets/img/sl3.png" },
        { image: "assets/img/sl3.png" },
      ],
    },
    {
      slider: [{ image: "assets/img/sl3.png" }],
    },
    {
      slider: [
        { image: "assets/img/sl3.png" },
        { image: "assets/img/sl3.png" },
      ],
    },
    {
      slider: [{ image: "assets/img/sl3.png" }],
    },
  ];

  return (
    <section
      className="main-container "
      style={{
        minHeight: window.innerHeight,
        overflow: "hidden",
      }}
    >
      <TheHeader
        navMenu={true}
        // namePage={`Trang Chủ`}
        // actionPage={`/home-page`}
      />
      <div className="main-inner home">
        <img src={urlAssetsCustom("assets/img/KV.png")} />
        <div className="container">
          <img
            className="d-none-mb"
            src={urlAssetsCustom("assets/img/sologan1.png")}
          />
          <img
            className="d-none"
            src={urlAssetsCustom("assets/img/sologan1-mb.png")}
          />
        </div>
        <BannerSlider
          listSlider={cardPhotographer}
          listSliderSetting={listSliderSetting}
          clickAction={props.handleOpenModalImage}
          // contentCard={contentCard}
          // setContentCard={setContentCard}
        />
        <div className="container">
          <img
            className="d-none-mb"
            src={urlAssetsCustom("assets/img/sologan2.png")}
          />
          <img
            className="d-none sologan2-mb"
            src={urlAssetsCustom("assets/img/sologan2-mb.png")}
          />
          {!showForm && (
            <div className="btn-wrapper create-card">
              <button
                id="btn-show-form"
                type="button"
                className="btn btn-primary btn-block"
                onClick={() => {
                  setShowForm(true);
                }}
              >
                <a>Tạo thiệp ngay!</a>
              </button>
              <p>
                Đã có <b>{totalCard}+</b> người tham gia
              </p>
            </div>
          )}
          {showForm && (
            <div className="register register-card">
              <form className="register-form" onSubmit={props.handleSubmit}>
                <img
                  className="d-none-mb"
                  src={urlAssetsCustom("assets/img/title-register.png")}
                />
                <img
                  className="d-none"
                  src={urlAssetsCustom("assets/img/title-register-mb.png")}
                />
                <br />
                <br />
                <div className="form-group">
                  <label className="title-form" htmlFor="usr">
                    Họ và tên <span>*</span>
                  </label>
                  <input
                    type="text"
                    className="form-control"
                    id="usr"
                    {...props.register("fullName")}
                    name="fullName"
                    placeholder="Nhập họ và tên..."
                    maxlength="30"
                    min="0"
                    max="30"
                  />
                </div>

                <div className="form-group">
                  <label className="title-form" htmlFor="phone">
                    Số điện thoại <span>*</span>
                  </label>
                  <div className="form-field ">
                    <input
                      type="tel"
                      className={`form-control ${
                        props?.isErrorPhoneNumber && "errors"
                      }`}
                      id="phone"
                      maxLength={10}
                      name="phone"
                      {...props.register("phone", {
                        onChange: (elm) => {
                          props.setValue(
                            "phone",
                            elm.target.value.replace(/[^\d]/gi, "")
                          );
                        },
                      })}
                      placeholder="Nhập số điện thoại..."
                      min="0"
                      max="10"
                      inputMode="numeric"
                    />
                  </div>
                  {props?.isErrorPhoneNumber && (
                    <small className="errors">Số điện thoại không hợp lệ</small>
                  )}
                  <div>
                    <small>
                      Vui lòng nhập số điện thoại có 10 chữ số bắt đầu bằng đầu
                      số 0
                    </small>
                  </div>
                </div>

                <div className="group-checkbox">
                  <div className="checkbox-item">
                    <label htmlFor="isAgree">
                      <input
                        type="checkbox"
                        value="isAgree"
                        name="isAgree"
                        id="isAgree"
                        {...props.register("isAgree")}
                      />
                      <span className="checkmark"></span>
                      <p>
                        Tôi đồng ý nhận các thông tin bán hàng, khuyến mãi,
                        quảng cáo, và khảo sát của Unilever.
                      </p>
                    </label>
                  </div>
                  <div className="checkbox-item">
                    <label htmlFor="isAgree1">
                      {/* <input
                      type="checkbox"
                      value="isAgree1"
                      name="isAgree1"
                      id="isAgree1"
                      {...props.register("isAgree1")}
                    />
                    <span className="checkmark"></span> */}

                      <p>
                        Bằng việc đăng ký, tôi xác nhận trên 16 tuổi và đã đọc
                        thông báo về{" "}
                        <a
                          className="policy"
                          target="_blank"
                          href="https://www.unilevernotices.com/vietnam/vietnamese/privacy-notice/notice.html"
                          rel="noreferrer"
                        >
                          quyền riêng tư
                        </a>{" "}
                        và{" "}
                        <a
                          className="policy"
                          target="_blank"
                          href="https://www.unilevernotices.com/vietnam/vietnamese/cookie-notice/notice.html"
                          rel="noreferrer"
                        >
                          Thông báo cookies
                        </a>{" "}
                        của Unilever để hiểu cách Unilever sử dụng thông tin của
                        tôi.
                      </p>
                    </label>
                  </div>
                  <div className="checkbox-item">
                    <label htmlFor="isAgree1">
                      <input
                        type="checkbox"
                        value="isAgree1"
                        name="isAgree1"
                        id="isAgree1"
                        {...props.register("isAgree1")}
                      />
                      <span className="checkmark"></span>
                      <p>
                        P/S có quyền sử dụng hình ảnh và lời chúc của người dùng
                        để tạo thiệp chúc mừng. Đọc hết điều khoản và điều kiện{" "}
                        <a
                          className="rule"
                          target="_blank"
                          href="https://docs.google.com/document/d/1y_DGrknmh5LsNZJ06NwR7NB2CNWU_AwNqUCw58AtIJk/edit?usp=sharing"
                          rel="noreferrer"
                        >
                          tại đây
                        </a>{" "}
                      </p>
                    </label>
                  </div>
                </div>
                <div className="btn-wrapper text-center">
                  <button
                    type="submit"
                    className="btn btn-primary btn-block disabled"
                    id="btn-register"
                  >
                    <a> Tạo thiệp</a>
                  </button>
                </div>
              </form>
            </div>
          )}
        </div>
        <BannerSlider
          listSlider={cardPhotoUser}
          typeSlider={1}
          listSliderSetting={listSliderSetting1}
          clickAction={props.handleOpenModalCard}

          // contentCard={contentCard}
          // setContentCard={setContentCard}
        />
        {/* <div style={{ width: 800,background:"blue" }}>
          <img style={{width:"100%"}}
            src="https://campaign0803qa.blob.core.windows.net/processed-image/BackgroundRemoval/me-lan-phuong-1-1728633960605834004902_background_removal_c8f102103d934e8ba35b23224611f3b2.png"
            alt=""
          />
        </div> */}
        <img
          className="img-full d-none-mb"
          src={urlAssetsCustom("assets/img/sologan3.png")}
        />
        <img
          className="img-full d-none"
          src={urlAssetsCustom("assets/img/sologan3-mb.png")}
        />
        <div className="video-block">
          <div className="video-warper">
            <div className="video-inner">
              <h3>
                CÙNG KIỂM CHỨNG ĐỘ LÀNH TÍNH CỦA <br />
                P/S TRẮNG RĂNG CẢ NHÀ NHÉ!
              </h3>
              <div className="videoWrapper">
                <iframe
                  width="100%"
                  height="100%"
                  src={LINK_VIDEO}
                  title="9 TUẦN LỄ VÀNG, SĂN VÀNG THẬT - Cơ hội trúng 90 chỉ vàng % 9,000 mã nạp điện thoại"
                  allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                  allowFullScreen
                ></iframe>
              </div>
            </div>
          </div>
          <img
            className="img-full bgrvideo"
            src={urlAssetsCustom("assets/img/bgrvideo.png")}
          />
          {/* <img
            className="img-full bgrvideo cuc-mb d-none"
            src={urlAssetsCustom("assets/img/cuc-mb.png")}
          /> */}
          {/* <img
            className="img-full bgrvideo cuc d-none-mb"
            src={urlAssetsCustom("assets/img/cuc.png")}
          /> */}
        </div>

        <TheFooter />
      </div>
    </section>
  );
};
export default HomeView;
